module.exports = __webpack_public_path__ + "img/13.62f3a096.jpg";